import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { CellText } from '~/pages/agent/components/agent/tableElements/cells/CellText';

function applicationIdCell(): ColumnsType<any>[0] {
  return {
    title: () => (
      <TableHeader title={getI18n().t('Application ID', { ns: 'agent' })} sortingDataKey="applicationDisplayId" />
    ),
    dataIndex: 'applicationDisplayId',
    key: 'applicationDisplayId',
    render: (applicationDisplayId) => <CellText>{applicationDisplayId ?? '—'}</CellText>,
    width: 160,
  };
}

export default applicationIdCell;
